import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export default function Footer() {
  return (
    <footer className="border-t border-slate-800 bg-obsidian" data-testid="site-footer">
      <div className="container-x grid gap-12 py-16 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo testId="footer-logo-link" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
            Listed equities and fractional real estate, managed from a single client ledger.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-5">Explore</p>
          <ul className="space-y-3 text-sm text-slate-300">
            <li><Link to="/markets" className="inline-block py-2.5 hover:text-emerald-400 md:py-1.5" data-testid="footer-markets-link">Stocks</Link></li>
            <li><Link to="/properties" className="inline-block py-2.5 hover:text-emerald-400 md:py-1.5" data-testid="footer-properties-link">Real estate</Link></li>
            <li><Link to="/register" className="inline-block py-2.5 hover:text-emerald-400 md:py-1.5" data-testid="footer-register-link">Open an account</Link></li>
            <li><Link to="/admin/login" className="inline-block py-2.5 hover:text-emerald-400 md:py-1.5" data-testid="footer-admin-link">Admin</Link></li>
            <li><Link to="/terms" className="inline-block py-2.5 hover:text-emerald-400 md:py-1.5" data-testid="footer-terms-link">Terms of Service</Link></li>
            <li><Link to="/privacy" className="inline-block py-2.5 hover:text-emerald-400 md:py-1.5" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/risk-disclosure" className="inline-block py-2.5 hover:text-emerald-400 md:py-1.5" data-testid="footer-risk-link">Risk Disclosure</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow mb-5">Contact</p>
          <ul className="space-y-3 text-sm text-slate-300" data-testid="footer-contact-details">
            <li>[Business address]</li>
            <li>[Phone number]</li>
            <li>[Contact email]</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="container-x flex flex-col gap-3 py-6 text-xs text-slate-500 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} Meridian Stock Exchange. All rights reserved.</p>
          <p className="max-w-xl">Investing involves risk, including loss of principal. Prices shown are set by Meridian and past performance does not guarantee future results.</p>
        </div>
      </div>
    </footer>
  );
}
